import styles from "./chatEventsInner.module.scss";
import { StatusTag } from "../../../../shared/widgets/statusTag";
import React, { useEffect } from "react";
import moment from "moment";
import { chatSideWindow } from "../../../../base/eventService/eventApiService";
import { complete_event_status } from "../../../../base/utils";
import { toastInformation } from "../../../../base/callService/common";
import { eventService } from "../../../../base/eventService/event.service";
type eventDataProps ={
  eventData:any;
  searchedData?: any;
  viewData?:any;
}
export default function ChatEventsInner({eventData,searchedData,viewData}:eventDataProps) {


  useEffect(() => {

  }, [searchedData]);

  let message_text = eventData && eventData?.summary.length > 30
    ? eventData?.summary.substring(0, 28) + "..." : eventData?.summary || "";
  
  message_text= message_text
    ?.replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/img,
      '<a href="$1" target="__blank">$1</a>');
  message_text = message_text?.replace(/\n/g, "<br />");
  if(searchedData!=="" && searchedData!== undefined && searchedData.search(/[\[\]?*+|{}\\.\n\r]/) === -1){
   
    const regexs = new RegExp('('+searchedData+')', 'gi');
    message_text = message_text?.replace(regexs,
      '<span style="background-color:#FFFF00" tabindex="0" class="tranText">$1</span>');
  }
  const showEvent = () => {
    new eventService().getEventByUid(eventData.uid)
      .then((response: any) => {
        if (response.status === "Ok") { chatSideWindow(true, "editevent", response.result); }
        else {
          toastInformation("The Event was deleted", "failure");
        }
      })
      .catch((err: any) => {
        console.log("err---", err);
      });

  };
  
  return (
    <>
      <div className={`eventsInner ${styles.eventsMessage}`} onClick={showEvent}>
        <div className={styles.eventsHeader}>
          <div className={styles.eventsStatus}>
            <span className={styles.eventsTitle}>
              <span className={styles.iconEvents}></span>
              <p dangerouslySetInnerHTML={{ __html: message_text?.replace(/\n/g, "<br />") }}></p>
            </span>
           
            <div className={styles.reviewBtn}>
            {complete_event_status((eventData.dtstart)*1000, (eventData.dtend)*1000)
                  === "Completed" ?
                    <StatusTag className='statusCompleted' name="Completed" />:
                    complete_event_status((eventData.dtstart)*1000, (eventData.dtend)*1000)
                  === "Yet To start"?
                      <StatusTag className='statusyettoStart' name="Yet To start" /> :
                      complete_event_status((eventData.dtstart)*1000, (eventData.dtend)*1000)
                    === "In Progress"&&
                    <StatusTag className='statusunderinProgress' name="In Progress"/>
                  }
            </div>
          </div>
          <div className={styles.eventsDetails}>
            <span className={styles.eventsDate}>
              {eventData && eventData.location && eventData.location.length > 15
                ? eventData.location.substring(0, 15) + "..." : eventData.location}
              <span className={styles.dotGrey}></span>
              {eventData && moment(new Date(eventData.dtstart * 1000)).format('ddd , MMM DD  YYYY')}</span>
          </div>
        </div>
      </div>
    </>
  );
};
